/**
 * Manages the retrieving of all of the locale specific strings.  This should be loaded with "common/managers/locale".
 */
import Locale from "common/managers/locale/Locale";
import cultures from "common/managers/cultures";
import nls from "common/assets/nls/nls";

const lang = context.language;
const locale = new Locale(nls.getStrings(lang), lang);
cultures.selectFormatting(nls.getFormatting(lang), locale);
export default locale;
